module.exports = __webpack_public_path__ + "static/media/Chattukam.36399b34.jpeg";